import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ChillRefer Error:", error, errorInfo);
  }

  handleReset = () => {
    // Clear all caches and storage, then reload
    try {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((regs) => {
          regs.forEach((r) => r.unregister());
        });
      }
      if ("caches" in window) {
        caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
      }
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {}
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          background: "#09090b",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          textAlign: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}>
          <h1 style={{ color: "#FACC15", fontSize: "1.5rem", fontWeight: 700, marginBottom: "8px" }}>
            ChillRefer
          </h1>
          <p style={{ color: "#fff", fontSize: "1rem", marginBottom: "4px" }}>
            Something went wrong
          </p>
          <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.85rem", marginBottom: "24px", maxWidth: "300px" }}>
            We hit an unexpected error. Tap below to reload.
          </p>
          <button
            onClick={this.handleReset}
            style={{
              padding: "14px 32px",
              background: "#FACC15",
              color: "#000",
              border: "none",
              borderRadius: "8px",
              fontWeight: 700,
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Reload App
          </button>
          <a
            href="https://wa.me/917996325666?text=Hi%20Shubham%2C%20ChillRefer%20is%20showing%20an%20error"
            style={{ color: "#25D366", fontSize: "0.8rem", marginTop: "16px", textDecoration: "none" }}
          >
            Need help? Chat with the Founder
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
